module.exports = __webpack_public_path__ + "02_veryshort_black.c70d6b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/02_veryshort_black.png
// module id = /Ntn
// module chunks = 0